import {
  CLEAR_ERRORS,
  CREATE_USER_API_KEY,
  FETCH_USER_INFO_REQUEST,
  FETCH_USER_INFO_RESPONSE,
  RECEIVE_DEVELOPER_KEY_ERRORS
} from '../constants/action-types'
import { handleResponse } from '../utils/response-utils'
import { getDeveloperAPIUrl, getUserInfoUrl } from '../utils/url-utils'

export const clearErrors = () => ({
  type: CLEAR_ERRORS
})

export const createUserAPIKey = response => ({
  type: CREATE_USER_API_KEY,
  payload: response
})

export const fetchUserInfoRequest = () => ({
  type: FETCH_USER_INFO_REQUEST
})

export const fetchUserInfoResponse = (response, error) => ({
  type: FETCH_USER_INFO_RESPONSE,
  payload: response,
  error
})

const receiveDeveloperKeyErrors = error => ({
  type: RECEIVE_DEVELOPER_KEY_ERRORS,
  error
})

export const fetchUserInfo = formData => dispatch => {
  dispatch(fetchUserInfoRequest())
  return fetch(`${getUserInfoUrl()}?${formData}`, {
    method: 'GET',
    credentials: 'same-origin',
    headers: {
      'content-type': 'application/x-www-form-urlencoded'
    }
  })
    .then(res => handleResponse(res))
    .then(data => dispatch(fetchUserInfoResponse(data, false)))
    .catch(error => dispatch(fetchUserInfoResponse(error, true)))
}

export const fetchNewAPIKey = email => dispatch => {
  const encodedEmail = encodeURIComponent(email)
  return fetch(`${getDeveloperAPIUrl()}/${encodedEmail}`, {
    method: 'POST',
    credentials: 'same-origin'
  })
    .then(res => handleResponse(res))
    .then(data => dispatch(createUserAPIKey(data)))
    .catch(error => dispatch(receiveDeveloperKeyErrors(error)))
}



// WEBPACK FOOTER //
// ./src/actions/user-info-actions.js